import React, { useEffect, useState } from "react";
import { Modal, Col, Row, Accordion } from "react-bootstrap";
import { systemAnnouncementDetailsApi } from "store/actions";
import { useDispatch, useSelector } from "react-redux";
import { DATE_FORMAT } from "helpers/common";
import { FadeLoader } from "react-spinners";
import styled from "styled-components";

export default function SystemAnnouncementModal({ show, handleClose, id }) {
  const { loading } = useSelector(({ SystemAnnouncement }) => SystemAnnouncement);
  const [data, setData] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (id) {
      fetchData();
    }
  }, [id]);

  const fetchData = () => {
    dispatch(
      systemAnnouncementDetailsApi({
        data: { _id: id },
        callBack: (err, response) => {
          const detail = response?.data;
          if (detail?._id) {
            setData(detail);
            console.info("System Announcement data ------->", detail);
          }
        },
      }),
    );
  };

  const cancelledNotifications = data?.scheduledTime?.filter(
    (item) => item?.scheduledStatus?.toLowerCase() === "cancelled"
  ) || [];

  const scheduledNotifications = data?.scheduledTime?.filter(
    (item) => item?.scheduledStatus?.toLowerCase() !== "cancelled"
  ) || [];

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
      size="lg"
    >
      <Modal.Header className="py-3 text-dark" closeButton>
        <Modal.Title className="fw-bold">System Announcement Details</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {loading ? (
          <div className="d-flex justify-content-center my-5">
            <FadeLoader />
          </div>
        ) : (
          <AccordionSec className="section">
            <Accordion defaultActiveKey="0" className="w-100">

              <Accordion.Item eventKey="0" className="border rounded mb-3">
                <Accordion.Header className="fw-bold text-dark p-0">
                  Details
                </Accordion.Header>
                <Accordion.Body>
                  <Row>
                    <Col lg={6} sm={12} className="my-2">
                      <p className="mb-0 font-weight-bold">Schedule ID</p>
                      <p>{data?.scheduleId || "--"}</p>
                    </Col>
                    <Col lg={6} sm={12} className="my-2">
                      <p className="mb-0 font-weight-bold">Message</p>
                      <p>{data?.message || "--"}</p>
                    </Col>

                    <Col lg={6} sm={12} className="my-2">
                      <p className="mb-0 font-weight-bold" >Type</p>
                      <p>{data?.type || "--"}</p>
                    </Col>

                    <Col lg={6} sm={12} className="my-2">
                      <p className="mb-0 font-weight-bold">Status</p>
                      <p>{data?.status || "--"}</p>
                    </Col>

                    <Col lg={6} sm={12} className="my-2">
                      <p className="mb-0 font-weight-bold">Maintenance</p>
                      <p>{data?.isMaintenance ? "YES" : "NO"}</p>
                    </Col>

                    {data?.isMaintenance && (
                      <>
                        <Col lg={6} sm={12} className="my-2">
                          <p className="mb-0 font-weight-bold">Actual Start Time</p>
                          <p>
                            {data?.actualStartAt
                              ? DATE_FORMAT(data?.actualStartAt)
                              : "--"}
                          </p>
                        </Col>

                        <Col lg={6} sm={12} className="my-2">
                          <p className="mb-0 font-weight-bold">Actual End Time</p>
                          <p>
                            {data?.actualEndAt
                              ? DATE_FORMAT(data?.actualEndAt)
                              : "--"}
                          </p>
                        </Col>

                        <Col lg={6} sm={12} className="my-2">
                          <p className="mb-0 font-weight-bold">Estimated Duration (mins)</p>
                          <p>{data?.estimatedDuration || "--"}</p>
                        </Col>
                      </>
                    )}


                    <Col lg={6} sm={12} className="my-2">
                      <p className="mb-0 font-weight-bold">Admin Name</p>
                      <p>{data?.adminDetails?.name || "--"}</p>
                    </Col>

                    <Col lg={6} sm={12} className="my-2">
                      <p className="mb-0 font-weight-bold">Admin Email</p>
                      <p>{data?.adminDetails?.email || "--"}</p>
                    </Col>

                    <Col lg={6} sm={12} className="my-2">
                      <p className="mb-0 font-weight-bold">Created At</p>
                      <p>
                        {data?.date_created_utc
                          ? DATE_FORMAT(data?.date_created_utc)
                          : "--"}
                      </p>
                    </Col>

                    <Col lg={6} sm={12} className="my-2">
                      <p className="mb-0 font-weight-bold">Modified At</p>
                      <p>
                        {data?.date_modified_utc
                          ? DATE_FORMAT(data?.date_modified_utc)
                          : "--"}
                      </p>
                    </Col>

                    <Col lg={12} sm={12} className="my-2">
                      <p className="mb-0 font-weight-bold">Description</p>
                      <p>{data?.description || "--"}</p>
                    </Col>
                  </Row>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="1" className="border rounded mb-3">
                <Accordion.Header className="fw-bold text-dark p-0">
                  Cancellation
                </Accordion.Header>
                <Accordion.Body>
                  <Row>
                    {data?.cancellationReason ? <>
                      <Col lg={6} sm={12} className="my-2">
                        <p className="mb-0 font-weight-bold">Cancellation Reason</p>
                        <p>
                          {data?.cancellationReason || "--"}
                        </p>
                      </Col>
                      <Col lg={6} sm={12} className="my-2">
                        <p className="mb-0 font-weight-bold">Cancellation Message</p>
                        <p>
                          {data?.cancellationMessage || "--"}
                        </p>
                      </Col>
                      <Col lg={6} sm={12} className="my-2">
                        <p className="mb-0 font-weight-bold">Cancelled At</p>
                        <p>
                          {data?.cancelledAt || "--"}
                        </p>
                      </Col>
                      <Col lg={6} sm={12} className="my-2">
                        <p className="mb-0 font-weight-bold">Cancelled Message Sent to User</p>
                        <p>
                          {data?.isCancelMessageToUser == true ? "Yes" : "No" || "--"}
                        </p>
                      </Col>
                      <Col lg={6} sm={12} className="my-2">
                        <p className="mb-0 font-weight-bold">Admin Name </p>
                        <p>
                          {data?.cancelledAdminDetails?.name || "--"}
                        </p>
                      </Col>
                      <Col lg={6} sm={12} className="my-2">
                        <p className="mb-0 font-weight-bold">Admin Email </p>
                        <p>
                          {data?.cancelledAdminDetails?.email || "--"}
                        </p>
                      </Col>
                    </> : <>
                      <Col lg="12" className="my-2">
                        <p className="text-muted text-center mb-0">No cancelled notifications found.</p>
                      </Col>
                    </>}
                  </Row>
                </Accordion.Body>
              </Accordion.Item>

              {data?.type === "Info" && data?.isMaintenance === true && (
                <Accordion.Item eventKey="2" className="border rounded mb-3">
                  <Accordion.Header className="fw-bold text-dark p-0">
                    Scheduled Notifications
                  </Accordion.Header>
                  <Accordion.Body>
                    {data?.scheduledTime?.length > 0 ? (
                      data?.scheduledTime.map((item, index) => (
                        <div key={index} className="border rounded p-3 mb-3 bg-light">
                          <h6 className="fw-bold border-bottom pb-2 mb-2">Notification #{index + 1}</h6>
                          <Row>
                            <Col lg={6} sm={12} className="my-2">
                              <p className="mb-0 font-weight-bold">Scheduled At</p>
                              <p>{item?.scheduledAt ? DATE_FORMAT(item.scheduledAt) : "--"}</p>
                            </Col>

                            <Col lg={6} sm={12} className="my-2">
                              <p className="mb-0 font-weight-bold">Scheduled Status</p>
                              <p className={`${item.scheduledStatus == "Pending" ? "text-warning" : item.scheduledStatus === "Sent" ? "text-success" : item.scheduledStatus === "Cancelled" ? "text-danger" : ""} text-primary fw-bold`}>{item?.scheduledStatus || "--"}</p>
                            </Col>
                            <Col lg={6} sm={12} className="my-2">
                              <p className="mb-0 font-weight-bold">Notification Sent</p>
                              <p>{item?.notificationSent ? "Yes" : "No"}</p>
                            </Col>
                            <Col lg={6} sm={12} className="my-2">
                              <p className="mb-0 font-weight-bold">Cancelled At</p>
                              <p>{item?.cancelledAt ? DATE_FORMAT(item.cancelledAt) : "--"}</p>
                            </Col>
                            <Col lg={6} sm={12} className="my-2">
                              <p className="mb-0 font-weight-bold">Cancellation Reason</p>
                              <p>{item?.cancellationReason || "--"}</p>
                            </Col>
                            <Col lg={6} sm={12} className="my-2">
                              <p className="mb-0 font-weight-bold">Cancelled Admin Name</p>
                              <p>{item?.cancelledByDetails?.name || "--"}</p>
                            </Col>
                            <Col lg={6} sm={12} className="my-2">
                              <p className="mb-0 font-weight-bold">Cancelled Admin Email</p>
                              <p>{item?.cancelledByDetails?.email || "--"}</p>
                            </Col>
                          </Row>
                        </div>
                      ))
                    ) : (
                      <p className="text-muted text-center mb-0">No scheduled notifications found.</p>
                    )}
                  </Accordion.Body>
                </Accordion.Item>
              )}
            </Accordion>
          </AccordionSec>
        )}
      </Modal.Body>
    </Modal>
  );
}

const AccordionSec = styled.div`
 .accordion-header{
  .accordion-button {
   background: transparent;
  }
 }
`
